<script>
import Layout from "../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { authFackMethods } from "@/state/helpers";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  page: {
    title: "Registration Progress",
    meta: [
      {
        name: "Registration Progress",
      },
    ],
  },
  components: { Layout, PageHeader, DatePicker },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      userTypes: [
        { value: "3", text: "Mentor" },
        { value: "4", text: "Volunteer" },
      ],
      statuses: [
        { value: "Incomplete", text: "Incomplete" },
        { value: "Not Approved", text: "Not Approved" },
      ],

      preservePage: 1,
      pageLimit: 50,
      registeredUsers: {},
      locations: null,
      searchForm: {
        username: null,
        psv_check: null,
        user_type_id: null,
        location_id: null,
        status: null,
        dateRange: null,
      },
      sort: {
        isSorted: false,
        sortKey: null,
        sortValue: null,
      },

      isName: false,
      isPsvCheck: false,
      isUserType: false,
      isSearching: false,
      isLoading: false,
      noRecord: false,
      searchBy: "",
      currentUserData: JSON.parse(localStorage.getItem("user")),
    };
  },
  mounted() {
    this.getRegisteredUsers();
    this.getLocations();
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return "";
      }
      return moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
    },
  },

  methods: {
    getRegisteredUsers(page) {
      this.noRecord = false;
      this.isLoading = true;
      if (typeof page === "undefined") {
        page = 1;
      }
      this.preservePage = page;
      let filter = "&per_page=" + this.pageLimit;
      if (this.searchForm.username) {
        filter += "&username=" + this.searchForm.username;
      }
      if (this.searchForm.email) {
        filter += "&email=" + this.searchForm.email;
      }

      if (this.searchForm.psv_check) {
        filter += "&psv_check=" + encodeURIComponent(this.searchForm.psv_check);
      }
      if (this.searchForm.user_type_id) {
        filter += "&user_type_id=" + this.searchForm.user_type_id;
      }

      if (this.searchForm.location_id) {
        filter += "&location_id=" + this.searchForm.location_id;
      }

      if (
        this.searchForm.dateRange != null &&
        this.searchForm.dateRange.length > 0 &&
        this.searchForm.dateRange[0] != null
      ) {
        var date_from = moment(this.searchForm.dateRange[0]).format(
          "YYYY-MM-DD"
        );
        var date_to = moment(this.searchForm.dateRange[1]).format("YYYY-MM-DD");
        filter += "&date_from=" + date_from + "&date_to=" + date_to;
      }

      if (this.sort.isSorted) {
        console.log("Sorted");
        filter += "&sort_key=" + this.sort.sortKey;
        filter += "&sort_value=" + this.sort.sortValue;
      }

      //if not admin
      if (
        this.currentUserData.user_type_id !== 1 &&
        this.currentUserData.user_type_id !== 5
      ) {
        filter += "&location=yes";
        filter += "&user_id=" + this.currentUserData.id;
      }
      filter += "&front_application_status=complete";

      axios
        .get("admin/users/all/registered?pagination=true&page=" + page + filter)
        .then((res) => {
          this.registeredUsers = res.data.response;
          this.isLoading = false;
          if (!this.registeredUsers.data.length) {
            this.noRecord = true;
            if (page > 1) {
              this.getRegisteredUsers(page - 1);
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status == 401) {
              this.logout();
            }
          }
        });
    },
    ...authFackMethods,

    searchOption(event) {
      this.searchForm = {
        username: null,
        psv_check: null,
        user_type_slug: null,
      };
      let selectedValue = event.target.value;
      if (selectedValue == "") {
        this.resetSearch();
      }
      if (selectedValue == "name") {
        this.getRegisteredUsers();
        this.isName = true;
        this.isPsvCheck = false;
        this.isUserType = false;
        this.isSearching = true;
      }
      if (selectedValue == "psv_check") {
        this.isName = false;
        this.isPsvCheck = true;
        this.isUserType = false;
        this.isSearching = true;
      }
      if (selectedValue == "user_type") {
        this.isName = false;
        this.isPsvCheck = false;
        this.isUserType = true;
        this.isSearching = true;
      }
    },
    getLocations() {
      axios.get("admin/locations").then((res) => {
        this.locations = res.data.response;
      });
    },

    searchRegisteredUsers() {
      this.getRegisteredUsers();
    },

    doSort(key) {
      this.sort.isSorted = true;
      if (this.sort.sortValue == null) {
        this.sort.sortValue = "asc";
      } else if (this.sort.sortValue == "asc") {
        this.sort.sortValue = "desc";
      } else {
        this.sort.sortValue = null;
        this.sort.isSorted = false;
      }

      this.sort.sortKey = key;

      this.getRegisteredUsers();
    },

    resetSearch() {
      this.searchForm = {
        username: null,
        psv_check: null,
        user_type_slug: null,
      };
      this.isSearching = false;
      this.isName = false;
      this.isPsvCheck = false;
      this.isUserType = false;
      this.searchBy = "";
      this.getRegisteredUsers();
    },

    getFullName(user) {
      let fullname = "";
      if (user.first_name && user.first_name.length) {
        fullname += user.first_name;
      }
      if (user.last_name && user.last_name.length) {
        fullname += " " + user.last_name;
      }
      return fullname;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!--Registration Progress-->
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Application Progress</h5>
          </div>
        </div>

        <!-- Search Filters  -->
        <form
          class="align-items-center form-inline mb-4 border p-3 m-0"
          @submit.prevent="searchRegisteredUsers"
        >
          <div class="row">
            <div class="col-md-3 mb-4">
              <label>User Name</label>
              <input
                v-model="searchForm.username"
                type="text"
                class="ps-4 form-control"
                placeholder="Type User Name"
                :disabled="isLoading"
              />
            </div>
            <div class="col-md-3 mb-4">
              <label>Email</label>
              <input
                v-model="searchForm.email"
                type="text"
                class="ps-4 form-control"
                placeholder="Type Email Address"
                :disabled="isLoading"
              />
            </div>
            <div class="col-md-3 mb-4">
              <label>Location</label>
              <b-form-select
                class="form-select"
                v-model="searchForm.location_id"
                :options="locations"
                value-field="id"
                text-field="name"
                :disabled="isLoading"
              >
                <option slot="first" :value="null">-- All Locations --</option>
              </b-form-select>
            </div>
            <div class="col-md-3 mb-4">
              <label>User Type</label>
              <b-form-select
                class="form-select"
                v-model="searchForm.user_type_id"
                :options="userTypes"
                :disabled="isLoading"
              >
                <option slot="first" :value="null">-- All User Types --</option>
              </b-form-select>
            </div>

            <div class="col-md-4 mb-4">
              <label>Submission date</label>
              <date-picker
                v-model="searchForm.dateRange"
                placeholder="Select date range"
                :disabled="isLoading"
                range
              ></date-picker>
            </div>
            <div class="col-md-5 mb-4">
              <div class="row">
                <div class="col-md-6 d-grid">
                  <label>&nbsp;</label>
                  <button
                    type="button"
                    @click="resetSearch"
                    class="btn btn-light btn-reset"
                    id="show-btn"
                  >
                    <i class="bx bx-reset"></i> Reset
                  </button>
                </div>
                <div class="col-md-6 d-grid">
                  <label>&nbsp;</label>
                  <button
                    type="submit"
                    class="btn btn-block btn-primary"
                    :disabled="isLoading"
                  >
                    <i class="bx bx-search-alt-2"></i> Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!-- /. Search Filters -->

        <div class="table-responsive">
          <table
            class="table table-bordered table-hover table-striped align-middle table-nowrap mb-0"
          >
            <thead class="table-light">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Status</th>
                <th scope="col">Type</th>
                <th
                  scope="col"
                  class="sortable"
                  @click="doSort('users.application_date')"
                >
                  Submission Date
                  <i
                    v-if="
                      sort.sortKey == 'users.application_date' &&
                      sort.sortValue == 'asc'
                    "
                    class="fa fa-sort-down"
                  ></i>
                  <i
                    v-else-if="
                      sort.sortKey == 'users.application_date' &&
                      sort.sortValue == 'desc'
                    "
                    class="fa fa-sort-up"
                  ></i>
                  <i v-else class="fa fa-sort"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="noRecord">
                <td colspan="4" class="p-0">
                  <p class="font-size-16 text-center mt-2 mb-0">
                    Record Not Found!
                  </p>
                </td>
              </tr>
              <tr v-if="isLoading">
                <td colspan="4" class="text-center p-0">
                  <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                </td>
              </tr>
              <tr
                v-else
                v-for="(
                  registeredUser, registeredUserIndex
                ) in registeredUsers.data"
                :key="registeredUserIndex"
              >
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    <router-link
                      tag="a"
                      :to="`/registration-progress/user/${registeredUser.id}`"
                      target="_blank"
                    >
                      <span>
                        {{
                          registeredUser.first_name != null
                            ? getFullName(registeredUser)
                            : registeredUser.username
                            ? registeredUser.username
                            : "N/A"
                        }}
                      </span>
                      <span
                        v-if="registeredUser.first_name == null"
                        class="badge border border-light rounded-circle bg-warning p-1"
                      >
                        <span class="visually-hidden">Incomplete profile</span>
                      </span>
                    </router-link>
                  </h5>
                </td>
                <td>
                  <h5 class="font-size-13 text-truncate mb-1">
                    <span v-if="registeredUser.psv_check == 'applicant'"
                      >Review Application</span
                    >
                    <span v-else>{{ registeredUser.user_current_status }}</span>
                  </h5>
                </td>
                <td>
                  <p class="text-muted mb-0">{{ registeredUser.UserType }}</p>
                </td>
                <td>
                  <p class="text-muted mb-0">{{ registeredUser.date }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          class="mt-4"
          :data="registeredUsers"
          :limit="10"
          @pagination-change-page="getRegisteredUsers"
        ></pagination>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.app-search input,
.app-search select {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.app-search .btn-find {
  width: 40%;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow: none;
}
.app-search .btn-reset {
  width: 40%;
  font-size: 15px;
  box-shadow: none;
  border-radius: 30px;
}
</style>
